import { Icon } from '@/assets';
import styles from './CalculatorMessages.module.scss';

interface CalculatorMessagesProps {
  plate: string;
  security?: string;
  variation: 'large' | 'small' | 'medium';
}
export const CalculatorMessages = ({
  plate,
  security,
  variation,
}: CalculatorMessagesProps) => {
  return (
    <div className={`${styles.messages} ${styles[variation]}`}>
      {security && <span className={styles.security}>{security}</span>}
      <span className={styles.plate}>
        <Icon icon="check" />
        {plate}
      </span>
    </div>
  );
};
